import { connect } from 'react-redux';
import { resetHttpError } from 'ducks/meta';
import HttpAlertDialog from './HttpAlertDialog';

const mapStateToProps = (state) => ({
  httpError: state.meta.httpError,
  localisation: state.localisation,
});

const mapDispatchToProps = {
  resetHttpError,
};

export default connect(mapStateToProps, mapDispatchToProps)(HttpAlertDialog);
